
<template>
  <div>
  <b-container fluid>
    <b-row>

      <b-col col cols="4" sm="2" md="2" lg="2">

        <b-card
        style="border:none; cursor:pointer"
        @mouseover="hover_in('dpp')" @mouseout="hover_out('dpp')"
        @click="showDoc('daily_power_position')"
        >
        <b-icon icon="lightning" font-scale="3" variant="dark" class="card-icon" id="dpp" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >দৈনিক শক্তিৰ স্থিতি</b-button>
      </b-card>

    </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
      <!-- <router-link to="" v-b-modal.annual-statement> -->
        <router-link to="/AS_AnnualStatement">
        <b-card
        style="border:none"
        @mouseover="hover_in('asa')" @mouseout="hover_out('asa')"
        >
        <b-icon icon="newspaper" font-scale="3" variant="dark" class="card-icon" id="asa" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" >একাউণ্টৰ বাৰ্ষিক বিবৃতি</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_QrtlyAccountStatement">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('qsa')" @mouseout="hover_out('qsa')"
        >
        <b-icon icon="clipboard-data" font-scale="3" variant="dark" class="card-icon" id="qsa" ></b-icon>
        <br><b-button variant="transparent" class="link" >  ত্ৰৈমাসিক অডিট কৰা একাউণ্ট বিবৃতি (২৩-২৪ বিত্তীয় বৰ্ষৰ পৰা) </b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_QrtlyAccountStatementLegacy">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('qsal')" @mouseout="hover_out('qsal')"
        >
        <b-icon icon="clipboard-data" font-scale="3" variant="dark" class="card-icon" id="qsal" ></b-icon>
        <br><b-button variant="transparent" class="link" >হিচাপৰ ত্ৰৈমাসিক বিবৃতি-নিৰীক্ষণ নকৰা  (লিগেচি ফৰ্মেট)</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_QrtlyAccountStatementMoP">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('qsam')" @mouseout="hover_out('qsam')"
        >
        <b-icon icon="clipboard-data" font-scale="3" variant="dark" class="card-icon" id="qsam" ></b-icon>
        <br><b-button variant="transparent" class="link" > হিচাপৰ ত্ৰৈমাসিক বিবৃতি-নিৰীক্ষণ নকৰা (এম.ও.পি. ফৰ্মেট)</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_AnnualReturnReport">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('annualRep')" @mouseout="hover_out('annualRep')"

        >
        <b-icon icon="layout-text-sidebar-reverse" font-scale="3" variant="dark" class="card-icon" id="annualRep" ></b-icon>
        <br><b-button variant="transparent" class="link" >কোম্পানীৰ বাৰ্ষিক ৰিটাৰ্ণ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <!-- <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_AuditorsReport">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('auditRep')" @mouseout="hover_out('auditRep')"

        >
        <b-icon icon="newspaper" font-scale="3" variant="dark" class="card-icon" id="auditRep" ></b-icon>
        <br><b-button variant="transparent" class="link" >অডিটৰৰ প্ৰতিবেদন</b-button>
      </b-card>
      </router-link>
    </b-col> -->
      <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_BodReport">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('directorRep')" @mouseout="hover_out('directorRep')"

        >
        <b-icon icon="file-earmark-text" font-scale="3" variant="dark" class="card-icon" id="directorRep" ></b-icon>
        <br><b-button variant="transparent" class="link" >পৰিচালকৰ প্ৰতিবেদন</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
        <b-card
        style="border:none;cursor:pointer"
        @mouseover="hover_in('lsr')" @mouseout="hover_out('lsr')"
        @click="showDoc('load_security_rate')"
        >
        <b-icon icon="box-arrow-up-left" font-scale="3" variant="dark" class="card-icon" id="lsr" ></b-icon>
        <br><b-button variant="transparent" class="link" >লোদ চিকিউৰিটিৰ হাৰ</b-button>
      </b-card>
</b-col>

  <b-col col cols="4" sm="2" md="2" lg="2">
    <b-card
        style="border:none;cursor:pointer"
        @mouseover="hover_in('dmp')" @mouseout="hover_out('dmp')"
        @click="showDoc('disaster_management_plan')"
        >
        <b-icon icon="cloud-slash" font-scale="3" variant="dark" class="card-icon" id="dmp" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" >দুৰ্যোগ ব্যৱস্থাপনা পৰিকল্পনা</b-button>
      </b-card>
    </b-col>

    <!-- <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="" v-b-modal.substation-list>
        <b-card
        style="border:none"
        @mouseover="hover_in('ss')" @mouseout="hover_out('ss')"
        >
        <b-icon icon="grid" font-scale="3" variant="dark" class="card-icon" id="ss" ></b-icon>
        <br><b-button variant="transparent" class="link" >List of 33/11 kv substations</b-button>
      </b-card>
      </router-link>
    </b-col> -->

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="" v-b-modal.energy_vision>
        <b-card
        style="border:none"
        @mouseover="hover_in('evd')" @mouseout="hover_out('evd')"
        >
        <b-icon icon="battery-charging" font-scale="3" variant="dark" class="card-icon" id="evd"></b-icon>
        <br><b-button variant="transparent" class="link textAlign15px" >অসম শক্তি দৰ্শন নথি</b-button>
      </b-card>
      </router-link>
    </b-col>
    <b-col col cols="4" sm="2" md="2" lg="2">
    <b-card
      title=""
      style="border:none;cursor:pointer"
      class="mb-2"
      @mouseover="hover_in('eps')" @mouseout="hover_out('eps')"
      @click="showDoc('Easy_Pay_SoP')"
      >
      <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="eps" ></b-icon>
      <br><b-button variant="transparent" class="link textAlign10px" >ইজি পে এছ.ও.পি.</b-button>
    </b-card>
    </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
      <b-card
        title=""
        style="border:none;cursor:pointer"
        class="mb-2"
        @mouseover="hover_in('rkr')" @mouseout="hover_out('rkr')"
        @click="showDoc('format_for_record_keeping')"
        >
        <b-icon icon="card-text" font-scale="3" variant="dark" class="card-icon" id="rkr" ></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >নথি সংৰক্ষণ পঞ্জীৰ বিন্যাস</b-button>
      </b-card>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_Forms">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('form')" @mouseout="hover_out('form')"
        >
        <b-icon icon="file-earmark" font-scale="3" variant="dark" class="card-icon" id="form" ></b-icon>
        <br><b-button variant="transparent" class="link" >ৰূপসমূহ </b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_Notices">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('notice')" @mouseout="hover_out('notice')"

        >
        <b-icon icon="list-ul" font-scale="3" variant="dark" class="card-icon" id="notice" ></b-icon>
        <br><b-button variant="transparent" class="link" >জাননীসমূহ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <!-- <router-link :to="{ path: 'Documents/ShutdownNotices', query: { circle: 'GECI' }}"> -->
      <router-link to="/AS_ShutdownCircle">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('shut')" @mouseout="hover_out('shut')"
        >
        <b-icon icon="x-square" font-scale="3" variant="dark" class="card-icon" id="shut" ></b-icon>
    <br>  <b-button   variant="transparent" class="link textAlign10px" >চাট্‌-দাউন জাননী</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_Reports">
        <b-card
        title=""
        style="border:none"
        class="mb-2 "
        @mouseover="hover_in('report')" @mouseout="hover_out('report')"
        >
        <b-icon icon="receipt" font-scale="3" variant="dark" class="card-icon" id="report" ></b-icon>
        <br><b-button variant="transparent" class="link" >খতিয়ানসমূহ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="" v-b-modal.white_paper>
        <b-card
        title=""
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('white')" @mouseout="hover_out('white')"
        >
        <b-icon icon="file-check" font-scale="3" variant="dark" class="card-icon" id="white"></b-icon>
        <br><b-button variant="transparent" class="link" >শ্বেতপত্ৰ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="" v-b-modal.notification>
        <b-card
        title=""
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('notification')" @mouseout="hover_out('notification')"
        >
        <b-icon icon="exclamation-circle" font-scale="3" variant="dark" class="card-icon" id="notification"></b-icon>
        <br><b-button variant="transparent" class="link textAlign20px" id="card-button">সূচনা</b-button>
      </b-card>
      </router-link>
    </b-col>

     <!-- <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/Documents/PressRelease">
        <b-card
        title=""
        style="max-width: 15rem;border:none"
        class="mb-2"
        @mouseover="hover_in('press')" @mouseout="hover_out('press')"
        >
        <b-icon icon="bookmark" font-scale="3" variant="dark" class="card-icon" id="press"></b-icon>
        <br><b-button variant="transparent" class="link" >Press Release</b-button>
      </b-card>
      </router-link>
    </b-col> -->

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="" v-b-modal.user-manuals>
        <b-card
        title=""
        style="border:none"
        class="mb-2 card-icon"
        @mouseover="hover_in('um')" @mouseout="hover_out('um')"
        >
        <b-icon icon="book" font-scale="3" variant="dark" class="card-icon" id="um"></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >ব্যৱহাৰকাৰীৰ মেনুৱেল</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_Circulars">
        <b-card
        title=""
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('circular')" @mouseout="hover_out('circular')"
        >
        <b-icon icon="card-heading" font-scale="3" variant="dark" class="card-icon" id="circular"></b-icon>
        <br><b-button variant="transparent" class="link textAlign10px" >চাৰ্কুলাৰ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_OfficeOrders">
        <b-card
        title=""
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('order')" @mouseout="hover_out('order')"
        >
        <b-icon icon="briefcase" font-scale="3" variant="dark" class="card-icon" id="order" ></b-icon>
        <br><b-button variant="transparent" class="link" >কাৰ্যালয় আদেশ</b-button>
      </b-card>
      </router-link>
    </b-col>

    <b-col col cols="4" sm="2" md="2" lg="2">
      <router-link to="/AS_Clarifications">
        <b-card
        title=""
        style="border:none"
        class="mb-2"
        @mouseover="hover_in('clarifications')" @mouseout="hover_out('clarifications')"
        >
        <b-icon icon="bag-check" font-scale="3" variant="dark" class="card-icon" id="clarifications"></b-icon>
        <br><b-button  variant="transparent" class="link textAlign20px" >স্পষ্টীকৰণ</b-button>
      </b-card>
      </router-link>
    </b-col>

      <!-- <b-col col cols="4" sm="2" md="2" lg="2">
        <router-link to="">
          <b-card
          title=""
          style="max-width: 15rem;border:none"
          class="mb-2"
          @mouseover="hover_in('electricalsafety')" @mouseout="hover_out('electricalsafety')"
          >
          <b-icon icon="bag-check" font-scale="3" variant="dark" class="card-icon" id="electricalsafety"></b-icon>
          <br><b-button  variant="transparent" class="link" >Electrical Safety</b-button>
        </b-card>
        </router-link>
      </b-col> -->

      <b-col col cols="4" sm="2" md="2" lg="2">
        <router-link to="/AS_EnergySavingTips">
          <b-card
          title=""
          style="border:none"
          class="mb-2"
          @mouseover="hover_in('energysavingtips')" @mouseout="hover_out('energysavingtips')"
          >
          <b-icon icon="lightning" font-scale="3" variant="dark" class="card-icon" id="energysavingtips"></b-icon>
          <br><b-button  variant="transparent" class="link" >শক্তি সঞ্চয়ৰ বাবে পৰামৰ্শ</b-button>
        </b-card>
        </router-link>
      </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
        <router-link to="/AS_DutiesOfConsumer">
          <b-card
          title=""
          style="border:none"
          class="mb-2"
          @mouseover="hover_in('dutiesofelectricity')" @mouseout="hover_out('dutiesofelectricity')"
          >
          <b-icon icon="bag-check" font-scale="3" variant="dark" class="card-icon" id="dutiesofelectricity"></b-icon>
          <br><b-button  variant="transparent" class="link textAlign15px" >বিদ্যুৎ উপভোক্তাৰ কৰ্তব্য</b-button>
        </b-card>
        </router-link>
      </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('hr')" @mouseout="hover_out('hr')"
          @click="showDoc('APDCL_HR_service_rules')"
          >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="hr" ></b-icon>
          <br><b-button variant="transparent" class="link" >এ.পি.দি.চি.এল. মানৱ সম্পদ সেৱা-নিয়মাৱলী, ২০১৯</b-button>
        </b-card>
      </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('it')" @mouseout="hover_out('it')"
          @click="showDoc('APDCL_IT_service_rules')"
          >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="it" ></b-icon>
          <br><b-button variant="transparent" class="link" >এ.পি.দি.চি.এল. তথ্য প্ৰযুক্তি সেৱা-নিয়মাৱলী,২০২১ </b-button>
        </b-card>
      </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('law')" @mouseout="hover_out('law')"
          @click="showDoc('APDCL_Law_service_rules')"
          >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="law" ></b-icon>
          <br><b-button variant="transparent" class="link" >  এ.পি.দি.চি.এল. আইন সেৱা-নিয়মাৱলী,২০২৩</b-button>
        </b-card>
      </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
        <router-link to="/AS_TechSpecification">
          <b-card
          title=""
          style="border:none"
          class="mb-2"
          @mouseover="hover_in('TechSpecification')" @mouseout="hover_out('TechSpecification')"
          >
          <b-icon icon="file-earmark-text" font-scale="3" variant="dark" class="card-icon" id="TechSpecification"></b-icon>
          <br><b-button  variant="transparent" class="link textAlign20px" >প্ৰামাণিক কাৰিকৰী নিৰ্দেশনা</b-button>
        </b-card>
        </router-link>
      </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/VendorList">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('vl')" @mouseout="hover_out('vl')"
        >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="vl" ></b-icon>
          <br><b-button variant="transparent" class="link" >বিক্ৰেতাৰ তালিকা</b-button>
        </b-card>
      </router-link>
      </b-col>

      <b-col col cols="4" sm="2" md="2" lg="2">
        <a href="https://www.apdcl.org/website/docs/documents/VendorList_DDUGJY.pdf" target="_blank">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('vlre')" @mouseout="hover_out('vlre')"
        >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="vlre" ></b-icon>
          <br><b-button variant="transparent" class="link" >ডিডিইউজিজেৱাই নতুন আঁচনিৰ বাবে বিক্ৰেতাৰ তালিকা</b-button>
        </b-card>
      </a>
      </b-col>
      <b-col col cols="4" sm="2" md="2" lg="2">
          <router-link to="/AS_CsrPolicy">
        <b-card
          style="border:none;cursor:pointer"
          @mouseover="hover_in('csr')" @mouseout="hover_out('csr')"
        >
          <b-icon icon="card-list" font-scale="3" variant="dark" class="card-icon" id="csr" ></b-icon>
          <br><b-button variant="transparent" class="link" >চি.এছ.আৰ. নীতি</b-button>
        </b-card>
      </router-link>
      </b-col>
      
    
    </b-row>
  </b-container>

  <div>

  <b-modal id="annual-statement" centered  scrollable title="Annual Statement of Accounts" hide-footer>
    <p class="" >
      <ul>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2022_23')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2022 - 2023</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2021_22')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2021 - 2022</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2020_21')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2020 - 2021</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2019_20')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2019 - 2020</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2018_19')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2018 - 2019</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2017_18')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2017 - 2018</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2016_17')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2016 - 2017</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2015_16')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2015 - 2016</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2014_15')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2014 - 2015</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2013_14')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2013 - 2014</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2012_13')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2012 - 2013</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2011_12')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2011 - 2012</a>
        </li>
        <li>
            <a href="#" @click="showDoc('annual_accounts_2010_11')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> 2010 - 2011</a>
        </li>
      </ul>
    </p>
  </b-modal>

  <b-modal id="energy_vision" centered  scrollable title="Assam Energy Vision Documents" hide-footer>
    <p class="" >
      <ul>
        <li>
            <a href="#" @click="showDoc('assam_energy_vision_draft_background')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon> Draft Background of Assam Energy Vision</a>
        </li>
        <li>
            <a href="#" @click="showDoc('assam_energy_vision_draft_summary')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>  Draft Summary of Assam Energy Vision</a>
        </li>
      </ul>
    </p>
  </b-modal>

  <b-modal id="white_paper" centered  scrollable title="White Paper" hide-footer>
    <p class="" >
      <ul>
        <li>
            <a href="#" @click="showDoc('white_paper_digital_metering')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>  White Paper on ADB Funded Digital Metering Programme</a>
        </li>
      </ul>
    </p>
  </b-modal>

  <b-modal id="notification" centered  scrollable title="Notification" hide-footer>
    <p class="" >
      <ul>
        <li>
            <a href="#" @click="showDoc('study_leave_amendment_rules_2019')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>  APDCL Study Leave (Amendment) Rules, 2019</a>
        </li>
      </ul>
    </p>
  </b-modal>

  <b-modal id="user-manuals" centered  scrollable title="User Manuals" hide-footer>
    <p class="">
      <ul>
        <li>
            <a href="#" @click="showDoc('Voluntary_Load_Declaration_Procedure')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               Procedure for Regularisation of Excess Load</a>
        </li>
        <!-- <li>
            <a href="#"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               Safety Manual </a>
             <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Safety_Manual_2019_English.pdf" target="_blank">(English |</a>
             <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Safety_Manual_2019_Assamese.pdf" target="_blank"> Assamese |</a>
             <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Safety_Manual_2019_Bengali.pdf" target="_blank"> Bengali)</a>
        </li>
        <li>
            <a href="https://www.apdcl.org/irj/go/km/docs/internet/ASSAM/webpage/PDF/Sachest2019.pdf" target="_blank"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               Sachest manual</a>
        </li> -->
        <li>
            <a href="#" @click="showDoc('How_to_Pay_Bills_Online')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               How to pay bills online</a>
        </li>
        <li>
          <a href="#" @click="showDoc('How_to_Recharge_Prepaid_Meter')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               How to Recharge Prepaid Meter online</a>
        </li>
        <li>
          <a href="#" @click="showDoc('How_to_Apply_New_Service_Connection')"><b-icon icon="file-earmark-text" font-scale="1"></b-icon>
               How to Apply for New Service Connection (LT) online</a>
        </li>
        <li>
          <a href="#" @click="showDoc('CMS_User_Manual')">
             <b-icon icon="file-earmark-text" font-scale="1"></b-icon>
              How to Register online in Contract Management System
          </a>
        </li>
      </ul>
    </p>
  </b-modal>
</div>

</div>

</template>
<style scoped="true">
  .link
  {
    font-size: 0.85rem;
    font-weight: 500;
    /* font-variant: small-caps; */
    padding:5px !important;
  }

  .card-icon
    {
        transition:1.2s;
        opacity: 0.9;
      /* color: #d84315 !important; */
    }

  .card-icon-hover{
    cursor:pointer;
    transition:1.2s;
    transform: scale(1) rotate(-360deg);
  }
  @media (max-width: 768px) {
  .textAlign20px{
    margin-left: -20px;
  }
  .textAlign15px{
    margin-left: -15px;
  }
  .textAlign10px{
    margin-left: -10px;
  }
}

</style>
<script>


import HeaderFixed from '@/components/HeaderFixed.vue'
import { mapGetters, mapActions } from 'vuex'

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {

  components: {
      'HeaderFixed' : HeaderFixed
    },
  data() {
      return {
        // TenderCurrentfields: [
        //   { key: 'description', label: 'Description',thStyle: {width: '40vw'} },
        //   { key: 'tender_no', label: 'Tender Number',thStyle: {width: '30vw'} },
        //   { key: 'important_dates', label: 'Important Dates',thStyle: {width: '20vw'} }
        // ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getDocument'


    ])
  },
  methods: {
    ...mapActions([
      'retrieveDocument'

    ]),
    hover_in(x){
      document.getElementById(x).classList.add("card-icon-hover");
    },
    hover_out(y){
      document.getElementById(y).classList.remove("card-icon-hover");
    },
    showDoc(id){
      var link = this.getDocument.filter(function(obj) { return obj.name == id; });
      console.log(link);
      window.open(this.$urlCommon +"/"+ link[0].path);
    },
    notice(id){
      window.open(this.$urlCommon +"/"+ id);
    }
  },
  beforeMount() {
      if(this.getDocument.length == 0){
        this.retrieveDocument()
      }
  }

}
</script>
